module.exports = __webpack_public_path__ + "img/mobile/Background/background-portrait@1x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Background/background-portrait@1x.jpg
// module id = 581
// module chunks = 0